"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAbrManager = void 0;
var abr_manager_1 = require("./abr-manager");
var abr_types_1 = require("./abr-types");
var bba_0_1 = require("./algorithms/bba-0/bba-0");
var bola_basic_1 = require("./algorithms/bola-basic/bola-basic");
var elastic_1 = require("./algorithms/elastic/elastic");
var llama_1 = require("./algorithms/llama/llama");
var quetra_1 = require("./algorithms/quetra/quetra");
var simple_network_1 = require("./algorithms/simple-network/simple-network");
var stallion_1 = require("./algorithms/stallion/stallion");
var buffer_assessment_1 = require("./buffer-assessment");
var getAbrManager = function (logger, playerConfig, abrConfig, networkEstimationProvider) {
    var algorithmSpecificConfig = abrConfig.algorithmSpecificConfig, bufferAssessmentConfig = abrConfig.bufferAssessmentConfig, bandwidthEstimation = abrConfig.bandwidthEstimation, experimental = abrConfig.experimental;
    var bufferAssessment = new buffer_assessment_1.BufferAssessment(logger, bufferAssessmentConfig || {});
    var bandwidthEstimator = networkEstimationProvider.createBandwidthEstimator(bandwidthEstimation, function () {
        return bufferAssessment.getStabilisedBufferAhead();
    });
    var latencyEstimator = networkEstimationProvider.createLatencyEstimator();
    var roundTripTimeEstimator = networkEstimationProvider.createRoundTripTimeEstimator();
    var abrAlgorithm;
    switch (algorithmSpecificConfig === null || algorithmSpecificConfig === void 0 ? void 0 : algorithmSpecificConfig.type) {
        case abr_types_1.AbrType.BOLA_BASIC:
            abrAlgorithm = new bola_basic_1.BolaBasic(logger, bufferAssessment, algorithmSpecificConfig);
            break;
        case abr_types_1.AbrType.BBA_0:
            abrAlgorithm = new bba_0_1.Bba0(logger, bufferAssessment, algorithmSpecificConfig);
            break;
        case abr_types_1.AbrType.STALLION:
            abrAlgorithm = new stallion_1.Stallion(logger, bandwidthEstimator, latencyEstimator, algorithmSpecificConfig);
            break;
        case abr_types_1.AbrType.SIMPLE_NETWORK:
            abrAlgorithm = new simple_network_1.SimpleNetwork(logger, bandwidthEstimator, latencyEstimator, bufferAssessment, algorithmSpecificConfig);
            break;
        case abr_types_1.AbrType.LLAMA:
            abrAlgorithm = new llama_1.Llama(logger, bandwidthEstimator, algorithmSpecificConfig);
            break;
        case abr_types_1.AbrType.QUETRA:
            abrAlgorithm = new quetra_1.Quetra(logger, bandwidthEstimator, bufferAssessment, algorithmSpecificConfig, playerConfig);
            break;
        case abr_types_1.AbrType.ELASTIC:
            abrAlgorithm = new elastic_1.Elastic(logger, bandwidthEstimator, bufferAssessment, roundTripTimeEstimator, algorithmSpecificConfig, playerConfig);
            break;
        case abr_types_1.AbrType.BUILT_IN:
        default:
            return undefined;
    }
    var abrManager = new abr_manager_1.AbrManager(logger, abrAlgorithm, bufferAssessment, bandwidthEstimator, latencyEstimator, roundTripTimeEstimator, experimental === null || experimental === void 0 ? void 0 : experimental.retryPolicy);
    return abrManager;
};
exports.getAbrManager = getAbrManager;
